import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type AccessoryPackItemClasses =
  | 'container'
  | 'packSelected'
  | 'titlePriceContainer'
  | 'multiCurrencyPriceText'
  | 'priceText'
  | 'priceGuideToggle'
  | 'multiCurrencyContainer'
  | 'checkbox';

const accessoryPackItemStyles = makeStyles<ISpcTheme, AccessoryPackItemClasses>(
  theme => ({
    container: {
      border: `1px solid ${theme.palette.primaryDisabled.main}`,
      padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
    },
    multiCurrencyContainer: {
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    packSelected: {
      borderColor: theme.palette.primary.main,
    },
    titlePriceContainer: {
      paddingTop: theme.spacing(0.75),
      paddingLeft: theme.spacing(1),
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    multiCurrencyPriceText: {
      fontSize: theme.typography.fontMD,
    },
    priceText: {
      fontFamily: theme.typography.fontFamily2,
      fontSize: theme.typography.fontLG,
    },
    priceGuideToggle: {
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSM,
    },
    checkbox: {
      top: 4,
      padding: 2,
    },
  }),
  { name: 'GqlCustomise_AccessoryPackItem' },
);

export default accessoryPackItemStyles;
